import styled from 'styled-components';
import { Background } from 'components/Generics/Background/Background.style';
import { EtoBackground } from 'components/Generics/Background/EtoBackground.style';
export const Content = styled.div`
    height: 82%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
`;

export const EtoLogoutMsg = styled.div`
    margin: 5vw 10vw 3vw 14vw;   // margin: top right bottom left;
    font-size: 4vw;
    font-family: 'Graphik Semibold', 'sans-serif';
    color: #003d50;
`;

export {
    Background,
    EtoBackground
};